import { Inject, Injectable } from '@angular/core';
import { combineLatest } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { WhiteLabel } from './white-label';
import { WHITE_LABEL_RULES, WhiteLabelRule, WhiteLabelRuleSnapshot } from './white-label-rule';

@Injectable()
export class WhiteLabelManagerService {
    public whiteLabel$ = combineLatest([
        ...this._whiteLabelRules.map(({ whiteLabelRule$ }) => whiteLabelRule$)
    ]).pipe(
        map<WhiteLabelRuleSnapshot<WhiteLabel>[], WhiteLabel>((ruleSnapshots) =>
            ruleSnapshots.reduce((whiteLabelMap, ruleSnapshot) => {
                whiteLabelMap = { ...whiteLabelMap, ...ruleSnapshot };
                return whiteLabelMap;
            }, {})
        ),
        shareReplay(1)
    );

    constructor(@Inject(WHITE_LABEL_RULES) private _whiteLabelRules: WhiteLabelRule<any>[]) {}
}
